import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/cn";

const base = [
	"t-body tap-target inline-flex w-fit cursor-pointer items-center gap-1.5 text-fg",
	"transition-colors duration-150 ease-smooth",
	"hover:text-brand-text",
	"focus-ring",
].join(" ");

interface LinkButtonCommon {
	state?: "default" | "hover";
	/** Опасное действие («Удалить аккаунт») — красный текст, тот же размер. */
	tone?: "default" | "danger";
	children?: ReactNode;
}

export interface LinkButtonProps
	extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type">,
		LinkButtonCommon {
	href?: undefined;
}

export interface LinkButtonAnchorProps
	extends AnchorHTMLAttributes<HTMLAnchorElement>,
		LinkButtonCommon {
	href: string;
}

/**
 * Строчное текстовое действие. Никогда не меняет размер и не подчёркивается —
 * на ховере меняется только цвет, поэтому текст вокруг не переливается.
 * С `href` рендерится ссылкой: «Читать» из Legal center — навигация, не кнопка.
 */
export function LinkButton(props: LinkButtonProps | LinkButtonAnchorProps) {
	const { state = "default", tone = "default", className, children, ...rest } = props;
	const classes = cn(
		base,
		tone === "danger" && "text-danger hover:text-danger",
		state === "hover" && tone !== "danger" && "text-brand-text",
		className,
	);

	if (typeof rest.href === "string") {
		const anchorProps = rest as AnchorHTMLAttributes<HTMLAnchorElement>;
		return (
			<a className={classes} {...anchorProps}>
				{children}
			</a>
		);
	}

	const buttonProps = rest as ButtonHTMLAttributes<HTMLButtonElement>;
	return (
		<button type="button" className={classes} {...buttonProps}>
			{children}
		</button>
	);
}
